import styled from '@emotion/styled';

export const SadaServicesList = styled.div``;
